import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { letterList } from '../../data/localData'
import { GoArrowUpRight } from 'react-icons/go'

function NewsLetter() {
    return (
        <div className='home-gap home-news-letter'>
            <Container>
                <h1 className='m-0 fs-md-24 fw-semibold text-center pb-3 pb-sm-4'>Latest News</h1>
                <Row>
                    <Col className='col-12 d-grid d-md-flex gap-3'>
                        {
                            letterList.map((letter, index) => {
                                return (
                                    <div key={index} className='letter-item d-grid align-content-end p-3'>
                                        <div className='flex-between gap-3'>
                                            <div className='letter-content d-grid'>
                                                <h5 className='fw-bold m-0 fs-18 fs-sm-16 letter-title'>{letter?.title}</h5>
                                                <p className='letter-description fw-light'>{letter?.description}</p>
                                            </div>
                                            <span>
                                                <GoArrowUpRight />
                                            </span>
                                        </div>
                                        <img src={letter?.image} alt="" />
                                    </div>
                                )
                            })
                        }
                    </Col>
                </Row>
                {/* <div className='flex-center-align pt-4 pt-md-5'>
                    <Link className='content-btn fw-semibold'>View All</Link>
                </div> */}
            </Container>
        </div>
    )
}

export default NewsLetter